import GiftRequestsTable from './GiftRequestsTable';
export default GiftRequestsTable;
